<template>
  <div>
    <div class="my-5 text-center offset-2 col-8">
      <img src="@/assets/welcome.svg" alt="" class="img-fluid" />
    </div>
    <div class="text-center">
      <h2>Jetzt registrieren</h2>
      <p>oder
        <a
           role="button"
           class="text-vue2"
           @click="changeComponent('LoginForm')"
        >
          melden Sie sich mit Ihrem Konto an
        </a>
      </p>
    </div>
    <Form @submit="submitData" :validation-schema="schema" v-slot="{errors}">
      <div class="form-body">
        <div class="form-row my-2">
          <div class="form-group col-md-8 offset-2">
            <label for="email"><strong>E-Mail-Adresse</strong></label>
            <Field as="input" type="email"
                   id="email"
                   name="email"
                   class="form-control"
                   placeholder="E-Mail Adresse"
            />
            <small class="text-danger" v-if="errors.email">
              {{ errors.email }}
            </small>
          </div>
        </div>
        <div class="form-row my-2">
          <div class="form-group col-md-8 offset-2">
            <label for="password"><strong>Password</strong></label>
            <Field as="input" type="password"
                   id="password"
                   name="password"
                   class="form-control"
                   placeholder="Password"
            />
            <small class="text-danger" v-if="errors.password">
              {{ errors.password }}
            </small>
          </div>
        </div>
        <div class="form-row my-2">
          <div class="form-group col-md-8 offset-2">
            <label for="confirmPassword"><strong>Password wiederholen</strong></label>
            <Field as="input" type="password"
                   id="confirmPassword"
                   name="confirmPassword"
                   class="form-control"
                   placeholder="Password wiederholen"
            />
            <small class="text-danger" v-if="errors.confirmPassword">
              {{ errors.confirmPassword }}
            </small>
          </div>
        </div>
        <div class="form-row mt-3">
          <div class="form-group col-md-8 offset-2">
            <div class="d-grid">
              <button class="btn bg-vue">Registrieren</button>
            </div>
          </div>
        </div>
      </div>
    </Form>
  </div>
</template>
<script>
import { Form, Field } from "vee-validate";
import * as yup from "yup";
import axios from "axios";
export default {
  name: "RegisterForm",

  components: {
    // 119;
    Form,
    Field
  },
  //121;
  emits: {
  "change-component": ( payload ) => {
      if ( payload.componentName !== "LoginForm" ) {
        return false;
      }
      return true;
    },
  },
  // 120;
  data () {
    const schema = yup.object().shape({
      email: yup
          .string()
          .required("E-Mail Adresse ist benötigt!")
          .trim()
          .email("Das ist keine gültige E-Mail Adresse!"),
      password: yup
          .string()
          .required("Eim Password wird benötigt!")
          .min(6, "Das Password muss mindestens sechs Zeichen lang sein."),
      confirmPassword: yup
          .string()
          .oneOf([yup.ref("password")], "Passwörter stimmen nicht überein!"),
    });
    return {
      schema,
    };
  },
  methods: {
    // 119;
    submitData( values ) {
      // 125;
     /* console.log( values );*/
      const singupDO = {
        email: values.email,
        password: values.password,
        returnSecureToken: true,
      };
      axios
          .post("https://identitytoolkit.googleapis.com/v1/accounts:signUp?key=AIzaSyBGDGZIfq7glCpoct6Q3TPAlQdZQ37rerQ",
          singupDO
      ).then((response) => {
        console.log(response.data);
      }).catch((error) => {
        console.log(error.response?.data);
      })
    },
    // 121;
    changeComponent( componentName ) {
      this.$emit("change-component", { componentName });
    },
  },
};
</script>
<style scoped>

</style>